<template>
  <div class="affiliate-bank-account-bank-account-information">
    <div class="bank-cover">
      <div class="bank">
        <p v-if="pageType === 'input'">
          アフィリエイトの利用に際して、まずは報酬の振込先となる銀行口座情報の登録をお願いいたします。
        </p>
        <table class="af-pop">
          <tr>
            <th>
              <div class="title">
                <span>銀行コード</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <el-input @blur="setBankName" v-model="userData.bankCode" style="width: 100px" />
                <ValidationErrorMessages :errorMessageList="validationErrorData.bankCode" />
              </div>
              <span v-else-if="pageType === 'confirm'">{{ userData.bankCode }}</span>
            </td>
          </tr>
          <tr>
            <th>
              <div class="title">
                <span>銀行名</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <el-input v-model="userData.bankName" style="width: 200px" disabled />
                <ValidationErrorMessages :errorMessageList="validationErrorData.bankName" />
              </div>
              <span v-else-if="pageType === 'confirm'">{{ userData.bankName }}</span>
            </td>
          </tr>
          <tr>
            <th>
              <div class="title">
                <span>支店コード</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <el-input @blur="setBranchName" v-model="userData.branchCode" style="width: 100px"
                  :disabled="userData.bankName === ''" />
                <ValidationErrorMessages :errorMessageList="validationErrorData.branchCode" />
              </div>
              <span v-else-if="pageType === 'confirm'">{{ userData.branchCode }}</span>
            </td>
          </tr>
          <tr>
            <th>
              <div class="title">
                <span>支店名</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <el-input v-model="userData.branchName" style="width: 200px" disabled />
                <ValidationErrorMessages :errorMessageList="validationErrorData.branchName" />
              </div>
              <span v-else-if="pageType === 'confirm'">{{ userData.branchName }}</span>
            </td>
          </tr>
          <tr>
            <th>
              <div class="title">
                <span>口座区分</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <el-select v-model="userData.accountType" placeholder="選択してください。">
                  <el-option v-for="bankAccountTypeData in bankAccountTypeList" :key="bankAccountTypeData.typeId"
                    :label="bankAccountTypeData.typeName" :value="bankAccountTypeData.typeId"></el-option>
                </el-select>
                <ValidationErrorMessages :errorMessageList="validationErrorData.accountType" />
              </div>
              <span v-else-if="pageType === 'confirm'">{{ bankAccountTypeName(userData.accountType) }}</span>
            </td>
          </tr>
          <tr>
            <th>
              <div class="title">
                <span>口座番号</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <el-input v-model="userData.accountNumber" style="width: 150px" />
                <ValidationErrorMessages :errorMessageList="validationErrorData.accountNumber" />
              </div>
              <span v-else-if="pageType === 'confirm'">{{ userData.accountNumber }}</span>
            </td>
          </tr>
          <tr>
            <th>
              <div class="title">
                <span class="sp-small">口座名義<br class="sp-only" />（カタカナ）</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <el-input v-model="userData.accountName" style="width: 200px" />
                <ValidationErrorMessages :errorMessageList="validationErrorData.accountName" />
              </div>
              <span v-else-if="pageType === 'confirm'">{{ userData.accountName }}</span>
            </td>
          </tr>
          <tr class="invoice">
            <th>
              <div class="title">
                <span class="sp-small">インボイス登録番号</span>
                <span v-if="pageType === 'input'" class="recquired">必須</span>
              </div>
            </th>
            <td>
              <div v-if="pageType === 'input'">
                <div class="invoice-radio-cover">
                  <el-radio v-model="userData.hasInvoiceRegistrationNumber" :label="true">あり</el-radio>
                  <el-radio v-model="userData.hasInvoiceRegistrationNumber" :label="false">なし</el-radio>
                </div>
                <ValidationErrorMessages :errorMessageList="validationErrorData.hasInvoiceRegistrationNumber" />
                <div v-if="userData.hasInvoiceRegistrationNumber === true" class="invoice-input-cover">
                  <el-input v-model="userData.invoiceRegistrationNumber" style="width: 200px" />
                </div>
                <ValidationErrorMessages :errorMessageList="validationErrorData.invoiceRegistrationNumber" />
              </div>
              <span v-else-if="pageType === 'confirm'">
                <span v-if="userData.hasInvoiceRegistrationNumber === true">{{ userData.invoiceRegistrationNumber
                  }}</span>
                <span v-else>なし</span>
              </span>
            </td>
          </tr>
        </table>
        <div class="register-button-cover">
          <template v-if="pageType === 'input'">
            <el-button @click="confirmBankAccountData" type="primary">確認</el-button>
          </template>
          <template v-else-if="pageType === 'confirm'">
            <el-button @click="pageType = 'input'" type="info">修正</el-button>
            <el-button @click="registerBankAccountData" type="primary">登録</el-button>
          </template>
        </div>
        <template id="affiliate-point-reward">
          <PointPaymentDescription v-if="$route.query.firstTime === 'true'" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PointPaymentDescription from "@/components/Affiliate/Parts/PointPaymentDescription.vue";
import ValidationErrorMessages from "@/components/Ui/ValidationErrorMessages.vue";

export default {
  name: "AffiliateBankAccountBankAccountInformation",
  components: {
    PointPaymentDescription,
    ValidationErrorMessages,
  },
  props: {},
  data() {
    return {
      // 
      pageType: "input",
      userData: {
        bankCode: "",
        bankName: "",
        branchCode: "",
        branchName: "",
        accountType: "",
        accountNumber: "",
        accountName: "",
        hasInvoiceRegistrationNumber: true, // 1: あり, 0: なし
        invoiceRegistrationNumber: "",
      },

      // 
      validationErrorData: {
        bankCode: [],
        bankName: [],
        branchCode: [],
        branchName: [],
        accountType: [],
        accountNumber: [],
        accountName: [],
        hasInvoiceRegistrationNumber: [],
        invoiceRegistrationNumber: [],
      }
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage", "bankAccountTypeList"]),
    ...mapGetters("affiliate", ["rewardBorderWithTax"]),
  },
  watch: {},
  created() {
    this.userData = JSON.parse(JSON.stringify(this.$store.getters["userData"]));
  },
  methods: {
    setBankName() {
      this.$axios
        .get(
          `https://apis.bankcode-jp.com/v1/banks/${this.userData.bankCode}?apiKey=bk_c540b863737e419fa6f3b8b81afee959`
        )
        .then((response) => {
          console.log(response);
          this.userData.bankName = response.data.name;
          return;
        })
        .catch((error) => {
          console.log(error);
          this.userData.bankName = "";
          return;
        });
    },
    setBranchName() {
      this.$axios
        .get(
          `https://apis.bankcode-jp.com/v1/banks/${this.userData.bankCode}/branches/${this.userData.branchCode}?apiKey=bk_c540b863737e419fa6f3b8b81afee959`
        )
        .then((response) => {
          console.log(response);
          if (response.data.length > 0) {
            this.userData.branchName = response.data[0].name;
          } else {
            this.userData.branchName = "";
          }
          return;
        })
        .catch((error) => {
          console.log(error);
          this.userData.branchName = "";
          return;
        });
    },
    confirmBankAccountData() {
      console.log("confirmBankAccountData");
      console.log(this.userData);

      // 
      let params = new URLSearchParams();
      params.append("bank_code", this.userData.bankCode);
      params.append("bank_name", this.userData.bankName);
      params.append("branch_code", this.userData.branchCode);
      params.append("branch_name", this.userData.branchName);
      params.append("account_type", this.userData.accountType);
      params.append("account_number", this.userData.accountNumber);
      params.append("account_name", this.userData.accountName);
      params.append("has_invoice_registration_number", this.userData.hasInvoiceRegistrationNumber === true ? '1' : '0');
      params.append("invoice_registration_number", this.userData.invoiceRegistrationNumber);
      this.$axios
        .post(
          `${this.rt}/l/api/user/validate-bank-account-data`,
          params
        )
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            // 
            this.validationErrorData.bankCode = [];
            this.validationErrorData.bankName = [];
            this.validationErrorData.branchCode = [];
            this.validationErrorData.branchName = [];
            this.validationErrorData.accountType = [];
            this.validationErrorData.accountNumber = [];
            this.validationErrorData.accountName = [];
            this.validationErrorData.hasInvoiceRegistrationNumber = [];
            this.validationErrorData.invoiceRegistrationNumber = [];

            // 
            this.pageType = "confirm";
          } else if (response.data.status === 400) {
            this.validationErrorData = response.data.validationErrorData;
            return;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    bankAccountTypeName(typeId) {
      // 
      let bankAccountTypeData = this.$store.getters["bankAccountTypeData"](typeId);

      // 
      return bankAccountTypeData.typeName;
    },
    registerBankAccountData() {
      // 
      let params = new URLSearchParams();
      params.append("bank_code", this.userData.bankCode);
      params.append("bank_name", this.userData.bankName);
      params.append("branch_code", this.userData.branchCode);
      params.append("branch_name", this.userData.branchName);
      params.append("account_type", this.userData.accountType);
      params.append("account_number", this.userData.accountNumber);
      params.append("account_name", this.userData.accountName);
      params.append("has_invoice_registration_number", this.userData.hasInvoiceRegistrationNumber === true ? '1' : '0');
      params.append("invoice_registration_number", this.userData.invoiceRegistrationNumber);
      this.$axios
        .post(
          `${this.rt}/l/api/user/register-bank-account-data`,
          params
        )
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {

            // 
            this.$store
              .dispatch("setUserData")
              .then((response2) => {
                console.log(response2);
                if (this.$route.query.firstTime !== "true") {
                  this.$router.go(-1);
                } else {
                  this.$router.push("/affiliate");
                }
              })
              .catch((error2) => {
                console.log(error2);
              });

          } else if (response.data.status === 400) {
            alert(response.data.message);
            return;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
table.af-pop {
  tr {
    &.invoice {
      td {
        padding-top: 0.8em;
        padding-bottom: 0.8em;

        .invoice-radio-cover {
          display: flex;
        }

        .invoice-input-cover {
          margin-top: 10px;
        }
      }
    }

    th {
      height: 40px;
      width: 30%;

      @media screen and (max-width: 768px) {
        width: 35%;
        font-size: 14px;
      }

      .title {
        display: flex;
        justify-content: space-between;

        @media screen and (max-width: 768px) {
          align-items: center;
        }

        .recquired {
          width: 2.5em;
          height: 25px;
          line-height: 25px;
          font-size: 0.75em;
          color: white;
          background-color: red;
          padding: 0px 2px;
        }
      }
    }

    td {
      text-align: left;

      span.addition {
        margin-left: 5px;
      }
    }
  }
}

.bank-cover {
  display: flex;
  justify-content: center;

  .bank {
    width: 70%;
  }
}

.sp-small {
  @media screen and (max-width: 768px) {
    font-size: 13px;
    margin-left: -10px;
  }
}
</style>
